import {
  FETCH_AGENT_SUPPORT_TICKETS_REQUEST,
  FETCH_AGENT_SUPPORT_TICKETS_SUCCESS,
  FETCH_AGENT_SUPPORT_TICKETS_FAILURE,
  UPDATE_AGENT_SUPPORT_TICKET_REQUEST,
  UPDATE_AGENT_SUPPORT_TICKET_SUCCESS,
  UPDATE_AGENT_SUPPORT_TICKET_FAILURE,
} from "../actions/types";

const initialState = {
  tickets: [],
  loading: false,
  error: null,
  message: "",
};

const agentSupportReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_AGENT_SUPPORT_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_AGENT_SUPPORT_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload,
        error: null,
        message: "Agent Support Tickets loaded successfully",
      };

    case FETCH_AGENT_SUPPORT_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_AGENT_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_AGENT_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: state.tickets.map((ticket) =>
          ticket.ticket_id === action.payload.ticket_id
            ? action.payload
            : ticket
        ),
        error: null,
        message: "Agent Support Ticket updated successfully",
      };

    case UPDATE_AGENT_SUPPORT_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default agentSupportReducer;